import { render, staticRenderFns } from "./FiltersEdit.vue?vue&type=template&id=6b7ca8ba&scoped=true&"
import script from "./FiltersEdit.vue?vue&type=script&lang=js&"
export * from "./FiltersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ca8ba",
  null
  
)

export default component.exports